import { getToken, isProdRunEnv } from '@/utils'
import { Router } from 'vue-router'
import { useAppStore } from '../store'
import { setBreadcrumbList } from './utils'

export function setupInterceptor (router: Router) {
  router.beforeEach((to, from, next) => {
    const app = useAppStore()
    const { authList, routeChainList } = app
    // 先设置title
    if (to.meta.title) {
      document.title = to.meta.title + ' - 巨商汇工作台'
    }

    if (isProdRunEnv && to.path === '/login' && getToken()) {
      next('/ai-helper')
      return
    }

    // 白名单配置
    if (['/403', '/404', '/login', '/login2', '/demo', '/app-download', '/resign-download'].includes(to.path)) {
      next()
      return
    }

    // 权限验证
    if (to.meta?.authCode && !authList.includes(to.meta.authCode)) {
      next('/403')
      return
    }

    // 压入路由链
    if (!to.name) {
      console.warn('当前路由没有name属性无法集成keepalive能力')
    } else if (Object.prototype.toString.call(to.name) === '[object Symbol]') {
      console.warn('路有配置：name属性为symble类型，无法支持keepalive能力')
    } else {
      routeChainList.push(to)
      console.log('app.routeChainList', routeChainList)
    }

    // 更新面包屑
    setBreadcrumbList(to)

    // 判断Token登录过期或者不存在
    if (!getToken()) {
      app.$patch({
        fallbackPath: to.path
      })
      next('/login')
      return
    }

    next()
  })

  router.afterEach((to, from) => {
    const app = useAppStore()
    // 把上个页面销毁掉 TODO： 仍然存在问题，生命周期执行错误
    const toRank = (to.meta.rank === null || to.meta.rank === undefined) ? 0 : to.meta.rank
    const currentRank = (from.meta.rank === null || from.meta.rank === undefined) ? 0 : from.meta.rank
    if (toRank > currentRank) {
      if (from.meta.keepAlive) {
        app.routeChainList = app.routeChainList.filter(route => route.path !== from.path)
      }
    }
  })
}
